import React, { useContext } from 'react';
import { ParkingsContext } from '../../contexts/ParkingsContext';
import ParkingCard from '../ParkingCard/ParkingCard';

function ParkingsCards() {
  const { parkings } = useContext(ParkingsContext);
  return parkings.map((parking) => <ParkingCard key={parking.id} {...parking} />);
}

export default ParkingsCards;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/ParkingsCards/ParkingsCards.jsx